import { EmailMassCommunicationForm } from "../EmailMassCommunicationForm";

export interface AddEmailMassCommunicationProps {}

export const AddEmailMassCommunication = () => {
  return <EmailMassCommunicationForm />;
};
